import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { CaseStageEnum } from "../../../../api/caseStages";
import {  useAppSelector } from "../../../../app/store";
import { useLoggedInUserId } from "../../../auth/logic/rbac";
import {
  selectCurrentCaseStage,
} from "../../../caseinfo/logic/Slice";
import WorkflowStageBanner from "../../../stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../stageWorkflow/components/WorkflowStageInfoBanner";
import { selectStageConfigByStage } from "../../logic/slice";
import { ParticipantType } from "../../../../../src/api/participants";

export const CreatorInfoAdditionStage: React.FC = () => {
  const loggedInUserId = useLoggedInUserId();
  const caseCreatorParticipant = useAppSelector((state) =>selectParticipantByType(state, ParticipantType.CASE_INITIATOR));

  const caseCreatedBy = caseCreatorParticipant?.participant_id;
  const currentStage = useAppSelector(selectCurrentCaseStage);

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.CREATOR_INFORMATION_ADDITION));

  const isCreator = loggedInUserId === caseCreatedBy;

  if (isCreator) {
    return (
      <WorkflowStageBanner
        title="Add Requested Information"
        description="Furnish the specific clarifications and documents as detailed in the comments. Your confirmation will re-submit the case for review."
        notes={currentStage?.stage_data?.notes}
        actions={stageConfig?.actions}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner title="Pending with Case Creator to add requested information." />
  );
};
